import languageServiceFactory from "../services/LanguageServiceImpl";

const languageService = languageServiceFactory();

/**
 * Formats a date string or Date object to a localized date string
 * @param date - Date string or Date object
 * @param options - Intl.DateTimeFormatOptions for date formatting
 * @returns Formatted date string
 */
export function formatDate(
    date: string | Date | null | undefined,
    options: Intl.DateTimeFormatOptions = {
        day: "numeric",
        month: "long",
        year: "numeric",
    }
): string {
    if (!date) return "";
    const dateObj = typeof date === "string" ? new Date(date) : date;
    const locale = languageService.getLocale();
    return dateObj.toLocaleDateString(locale, options);
}

/**
 * Formats a date to show only date (day, month, year)
 * @param date - Date string or Date object
 * @returns Formatted date string (e.g., "15 січня 2024")
 */
export function formatDateLong(date: string | Date | null | undefined): string {
    return formatDate(date, {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
}

/**
 * Formats a date to show date and time
 * @param date - Date string or Date object
 * @returns Formatted date string with time
 */
export function formatDateTime(date: string | Date | null | undefined): string {
    return formatDate(date, {
        hour: "2-digit",
        minute: "2-digit",
    });
}

